export const state = () => {
	return {
		program: {},
		ttl_program: null,
		cache_duration_program: 3600000, // 1 hour
		cache_key_program: '',
	}
}

function isInCacheProgram(state, companyId) {
	if (state.cache_key_program !== buildCacheKeyProgram(companyId)) {
		return false
	}
	if (state.ttl_program === null || state.ttl_program < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyProgram(companyId) {
	return `company:${companyId}:referral-program`
}

export const actions = {
	async get({ state, commit }, { companyId, force }) {
		if (!force && isInCacheProgram(state, companyId)) {
			return state.program
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/referral-program/`)
			.then((res) => {
				commit('setProgram', { data: res, companyId })
				return res
			})
			.catch((err) => {
				throw err
			})
	},

	async partialUpdate({ commit, dispatch }, { companyId, programId, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/referral-program/${programId}/`, {
				method: 'PATCH',
				body: data,
			})
			.then(() => {
				commit('invalidateCacheProgram')
				dispatch('get', { companyId })
			})
	},

	async create({ commit }, { companyId, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/referral-program/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => {
				commit('setProgram', { data: res, companyId })
			})
	},

	async createDefaultProgram({ commit }, { companyId, storeUrl }) {
		const data = {
			company: companyId,
			enable: false,
			redirect_url: storeUrl,
			godfather_reward: {
				company: companyId,
				attributed_to: 2,
				type: 3,
				validity: 30,
				amount: 10,
				prerequisite_amount: 10,
				image_url: 'https://assets.loyoly.io/public/icons/voucher.png',
			},
			godson_reward: {
				company: companyId,
				attributed_to: 1,
				type: 3,
				validity: 7,
				amount: 10,
				prerequisite_amount: 10,
				image_url: 'https://assets.loyoly.io/public/icons/voucher.png',
			},
			use_segment: true,
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/referral-program/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => {
				commit('setProgram', { data: res, companyId })
			})
	},
}

export const mutations = {
	setProgram(state, { data, companyId }) {
		state.program = data
		state.ttl_program = Date.now() + state.cache_duration_program
		state.cache_key_program = buildCacheKeyProgram(companyId)
	},

	invalidateCacheProgram(state) {
		state.ttl_program = null
		state.cache_duration_program = ''
	},
}
